export default "__VITE_ASSET__DvOIXcSt__"